import { addItem, getItems, updateItem, deleteItem } from './db';

let OrdersTable = 'Orders';

export const OrderStatus = {
    Pending: 'Pendente',
    Failed: 'Falhou',
    Sincronized: 'Sincronizado'
}

export async function saveLocalOrder(data) {
    await addItem(OrdersTable, data, 'local_id');
}

export async function setSincronizedOrderById(local_id, data) {
    await updateItem(OrdersTable, local_id, data);
}

export async function getOrders() {
    return await getItems(OrdersTable);
}

export async function getPendingOrders() {
    return await getItems(OrdersTable, IDBKeyRange.only('Pendente')); // , 'Pending'
    // let items = await getItems(OrdersTable, IDBKeyRange.only('Pendente')); // 
    // return items.filter(record => record.status === 'Pendente');
}